"use client";

import React from "react";
import s from "../styles";
import Consts from "@common/config/consts";
import logjs from "@metrojs/logjs";
const log = new logjs("PhotoListArea");
import { providers } from "@lib/client";
const { useWebAppContext } = providers;
import { useState } from "react";
import { Modal, Box } from "@mui/material";
import Image from "next/image";

/**
 * 写真表示コンポーネント
 * @param {Object} props - プロパティ
 * @param {Object} props.data - データオブジェクト
 * @param {string} props.quote_number - 見積番号
 * @param {Object} props.photoDialogProps - 写真ダイアログのプロパティ
 * @returns {JSX.Element} 写真表示コンポーネント
 */
export default function PhotoListArea({ form, formProps, data, quote_number, photoDialogProps }) {
  // 写真が表示可能かチェック
  const canShowPhotos = !data?.request?.GenshaID && data?.request?.CorpID && data?.request?.MitsumoriNo && Array.isArray(data?.pictList) && data.pictList.length > 0;

  const [previewPict, setPreviewPict] = useState(null);
  const { state } = useWebAppContext();
  if (!canShowPhotos) {
    return null;
  }

  return (
    <>
    <s.PhotoSection>
      <s.DetailTable>
        <s.DetailCaption>写真</s.DetailCaption>
        <tbody>
          {/* 5列ずつの行に分割 */}
          {Array.from({ length: Math.ceil(data.pictList.length / 5) }, (_, rowIndex) => (
            <tr key={rowIndex}>
              {data.pictList.slice(rowIndex * 5, (rowIndex + 1) * 5).map((pict, colIndex) => {
                const index = rowIndex * 5 + colIndex;

                // 画像パス処理（PHPの処理をJavaScriptに変換）
                // const imgPath = String(pict.PictPath || "").replace(/^[\\/]+/, "");
                const imgPath = pict.PictPath ? pict.PictPath.replace(/^\/+/, "") : "";
                if (!imgPath) return null;

                const pos = imgPath.lastIndexOf(".");
                if (pos === -1) return null; // 拡張子が見つからない場合はスキップ

                const extent = imgPath.substring(pos + 1);
                const fName = imgPath.substring(0, pos);
                const thumbnailPath = `${fName}_s.${extent}`;

                // キャッシュバスター用のタイムスタンプ
                const dateTime = new Date()
                  .toLocaleString("ja-JP", {
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })
                  .replace(/[\/\s:]/g, "");

                // 画像URL生成（安全なURL生成）
                const imageFolder = "/images";
                const corpId = String(data?.request?.CorpID || "").trim();
                const mitsumoriNo = String(data?.request?.MitsumoriNo || "").trim();

                // URLの各要素をエンコード
                const fullImageUrl = `${state?.initData?.S3ImageFolderDirect}/${imgPath}?${dateTime}`;
                const thumbnailUrl = `${state?.initData?.S3ImageFolderDirect}/${imgPath.replace(/\.(png|jpg|jpeg)$/i, "_s.$1")}?${dateTime}`;

                return (
                  <s.DetailTd key={pict.id}>
                    <a
                      href="#"
                      className="fancybox"
                      rel="group1"
                      onClick={(e) => {
                        e.preventDefault();
                        setPreviewPict(pict);
                      }}
                    >
                      <img
                        src={thumbnailUrl}
                        style={{ maxWidth: "100px", maxHeight: "100px", objectFit: "cover" }}
                        onError={(e) => {
                          // 画像読み込みエラー時の処理
                          const img = e.currentTarget;
                          img.onerror = null;
                          img.src = "/images/noimage.png"; // プレースホルダー
                        }}
                      />
                    </a>
                  </s.DetailTd>
                  
                );
              })}
            </tr>
          ))}
        </tbody>
      </s.DetailTable>
    </s.PhotoSection>
    {/* 写真モーダル */}
    <Modal open={!!previewPict} onClose={() => setPreviewPict(null)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          height: 400,
          bgcolor: "#fff",
          borderRadius: 1,
          boxShadow: 24,
          p: 1,
          outline: "none",
        }}
      >
        {/* × ボタン */}
        <Box
          onClick={() => setPreviewPict(null)}
          sx={{
            position: "absolute",
            top: -12,
            right: -12,
            zIndex: 10,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#000",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: 20,
            fontWeight: "bold",
            border: "2px solid #fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
          }}
        >
          ×
        </Box>

        {/* 拡大画像 */}
        <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
          <Image
            src={
              previewPict
                ? `${state?.initData?.S3ImageFolderDirect}/${previewPict.PictPath.replace(/^\/+/, "")}?v=${Date.now()}`
                : ""
            }
            alt=""
            fill
            sizes="400px"
            style={{ objectFit: "contain" }}
          />
        </Box>
      </Box>
    </Modal>
    </>
  );
}
